import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DEFAULT_SNACKBAR_CONFIG } from 'src/app/@shared/constants/site.constants';
import { EventPrintAttributeDefinition } from '../../../models/event-print-attribute.model';
import { IPrintPage } from '../../../models/print-page.model';
import { PrintAttributeType } from '../../../models/print-attribute.model';
import { EventPrintAttributeService } from '../../../services/event-print-attribute.service';
import { OfferPromoService } from '../../../services/offerpromo.service';
import { OfferPromo } from '../../../models/offer-promo.model';
import { PromoDomain } from '../../../models/promo-domain.model';
import { PrintAttributeService } from '../../../services/print-attribute.service';
import { takeUntil } from 'rxjs';

interface AssignPageDialogData {
  eventId: string;
  selectedRecords: EventPrintAttributeDefinition[];
}

@Component({
  selector: 'app-assign-page',
  templateUrl: './assign-page.component.html',
  styleUrls: ['./assign-page.component.scss'],
})
export class AssignPageComponent implements OnInit {
  private static readonly chipToneStyles: Readonly<
    Record<string, { background: string; borderColor: string; color: string }>
  > = {
    address: { background: '#e8eaf6', borderColor: '#c5cae9', color: '#1e3a8a' },
    'sale_dates': { background: '#fff3e0', borderColor: '#ffcc80', color: '#ef6c00' },
    url: { background: '#e3f2fd', borderColor: '#90caf9', color: '#1565c0' },
    'printer_code': { background: '#f3e5f5', borderColor: '#ce93d8', color: '#6a1b9a' },
    header: { background: '#e8eaf6', borderColor: '#9fa8da', color: '#283593' },
    creative: { background: '#fce4ec', borderColor: '#f48fb1', color: '#ad1457' },
    'market_place': { background: '#e0f2f1', borderColor: '#80cbc4', color: '#006064' },
    'offer_event': { background: '#fff8e1', borderColor: '#ffe082', color: '#c17900' },
    abev: { background: '#efebe9', borderColor: '#bcaaa4', color: '#795548' },
    'dry_version': { background: '#eceff1', borderColor: '#b0bec5', color: '#455a64' },
    unknown: { background: '#e8eaf6', borderColor: '#c5cae9', color: '#1e3a8a' },
  };

  attributeTypeOptions: { id: string; label: string }[] = [];

  printPagesList: IPrintPage[] = [];
  selectedPrintPageId = '';

  constructor(
    private offerPromoService: OfferPromoService<OfferPromo, PromoDomain<OfferPromo>>,
    private eventPrintAttributeService: EventPrintAttributeService,
    private matSnackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AssignPageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AssignPageDialogData,
    private printAttributeService: PrintAttributeService,
  ) {}

  ngOnInit(): void {
    if (!this.data?.eventId) {
      return;
    }

    this.printAttributeService.printAttributeTypes$.subscribe((types) => {
      this.attributeTypeOptions = types;
    });

    this.offerPromoService
      .GetAllPrintPagesByEventforOffers(this.data.eventId)
      .subscribe((res) => {
        this.printPagesList = Array.isArray(res) ? res : [];
      });
  }

  closeDialog(result = false): void {
    this.dialogRef.close(result);
  }

  apply(): void {
    const attributeIds = (this.data?.selectedRecords ?? [])
      .map((record) => record.DomainId || record.Id || '')
      .filter(Boolean);

    if (!this.selectedPrintPageId || !attributeIds.length) {
      return;
    }

    this.eventPrintAttributeService
      .assignPrintPage(this.selectedPrintPageId, attributeIds, this.data.eventId)
      .subscribe({
        next: () => {
          this.matSnackBar.open(
            'Page assigned for selected attributes',
            'OK',
            DEFAULT_SNACKBAR_CONFIG,
          );
          this.closeDialog(true);
        },
        error: () => {
          this.matSnackBar.open('Failed to assign page', 'OK', DEFAULT_SNACKBAR_CONFIG);
        },
      });
  }

  getPrintAttributeTypeLabel(typeId: string): string {
    const type = this.attributeTypeOptions.find(t => t.id === typeId);
    return type ? type.label : typeId;
  }
}
